'use client';

import Link from 'next/link';
import { AnchorHTMLAttributes, forwardRef, useRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';

import type { TextElementType, CommonTypographyProps } from './typing';
import styles from './index.module.css';

export const Typography = forwardRef<TextElementType, CommonTypographyProps>(
  ({ view = 'medium_14', color, href, tag: Component = 'p', className, children, onClick, ...restProps }, ref) => {
    const textRef = useRef<HTMLElement>(null);

    if (href) {
      const { target } = restProps as AnchorHTMLAttributes<HTMLAnchorElement>;

      return (
        <Link
          rel={target === '_blank' ? 'noreferrer noopener' : undefined}
          href={href}
          style={{ color }}
          className={cn(styles.component, styles[view], className)}
          {...restProps}
        >
          {children}
        </Link>
      );
    }

    return (
      <Component
        style={{ color }}
        className={cn(styles.component, styles[view], className)}
        ref={mergeRefs([textRef, ref])}
        onClick={onClick}
      >
        {children}
      </Component>
    );
  },
);

Typography.displayName = 'Typography';
